// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-wrapper {
  padding: 30px 40px;
  text-align: center;
  max-width: 100%;
}
.modal-wrapper .modal-header {
  margin-bottom: 35px;
}
.modal-wrapper .modal-header h1 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
}
.modal-wrapper .modal-header p {
  font-size: 0.95rem;
  color: #777;
  margin: 0;
  line-height: 1.4;
}
.modal-wrapper .row-selectors {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
  margin-bottom: 15px;
}
.modal-wrapper .row-selectors .field {
  flex: 1;
}
.modal-wrapper .row-selectors .field ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0;
}
.modal-wrapper .row-selectors .divider-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
}
.modal-wrapper .row-selectors .divider-icon img {
  width: 28px;
  height: auto;
}
.modal-wrapper .row-checkbox {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 45px;
}
.modal-wrapper .row-checkbox ::ng-deep .mat-checkbox-layout {
  white-space: normal;
}
.modal-wrapper .row-checkbox .checkbox-text {
  color: #666;
  font-size: 0.95rem;
}
.modal-wrapper .row-checkbox ::ng-deep .mat-checkbox-checked.mat-warn .mat-checkbox-background {
  background-color: #b71c1c !important;
}
.modal-wrapper .modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
}
.modal-wrapper .modal-footer .btn-confirm {
  min-width: 150px;
  padding: 6px 40px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 1rem;
  text-transform: none;
  background-color: #e0e0e0;
  color: #8a8a8a;
}
.modal-wrapper .modal-footer .btn-confirm:not(:disabled) {
  background-color: #b71c1c !important;
  color: white !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.modal-wrapper .modal-footer .btn-cancel {
  color: #b71c1c;
  font-weight: 700;
  font-size: 1rem;
  text-transform: none;
}
.modal-wrapper .modal-footer .btn-cancel:hover {
  background: transparent;
  text-decoration: underline;
}

@media (max-width: 600px) {
  .modal-wrapper {
    padding: 20px 15px;
  }
  .modal-wrapper .row-selectors {
    flex-direction: column;
    gap: 10px;
  }
  .modal-wrapper .row-selectors .field {
    width: 100%;
  }
  .modal-wrapper .row-selectors .divider-icon {
    width: 100%;
    height: auto;
    margin: 5px 0 15px 0;
    transform: rotate(90deg);
  }
  .modal-wrapper .row-selectors .divider-icon img {
    width: 32px;
  }
  .modal-wrapper .row-checkbox {
    margin-bottom: 30px;
  }
  .modal-wrapper .modal-footer {
    flex-direction: column;
    gap: 15px;
  }
  .modal-wrapper .modal-footer .btn-confirm {
    width: 100%;
    order: 1;
  }
  .modal-wrapper .modal-footer .btn-cancel {
    order: 2;
  }
}
.buttons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 32px;
}
.buttons .btn-back {
  width: 8rem !important;
}
.buttons a {
  text-decoration: none;
  color: #AE0F0A;
  margin-left: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/modals/modal-clone-feriado/modal-clone-feriado.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AACF;AAEE;EACE,mBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAAN;AAGI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AADN;AAME;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAJJ;AAMI;EACE,OAAA;AAJN;AAOM;EACE,iBAAA;AALR;AASI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAPN;AASM;EACE,WAAA;EACA,YAAA;AAPR;AAaE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAXJ;AAaI;EACE,mBAAA;AAXN;AAcI;EACE,WAAA;EACA,kBAAA;AAZN;AAgBI;EACE,oCAAA;AAdN;AAmBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAjBJ;AAoBI;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EAGA,yBAAA;EACA,cAAA;AApBN;AAuBM;EACE,oCAAA;EACA,uBAAA;EACA,wCAAA;AArBR;AA0BI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAxBN;AA0BM;EACE,uBAAA;EACA,0BAAA;AAxBR;;AA+BA;EACE;IACE,kBAAA;EA5BF;EA8BE;IACE,sBAAA;IACA,SAAA;EA5BJ;EA8BI;IACE,WAAA;EA5BN;EA+BI;IACE,WAAA;IACA,YAAA;IACA,oBAAA;IACA,wBAAA;EA7BN;EA+BM;IACE,WAAA;EA7BR;EAkCE;IACE,mBAAA;EAhCJ;EAmCE;IACE,sBAAA;IACA,SAAA;EAjCJ;EAmCI;IACE,WAAA;IACA,QAAA;EAjCN;EAoCI;IACE,QAAA;EAlCN;AACF;AAsCA;EACC,WAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AApCF;AAqCG;EACC,sBAAA;AAnCJ;AAqCE;EACI,qBAAA;EACA,cAAA;EACA,iBAAA;AAnCN","sourcesContent":[".modal-wrapper {\n  padding: 30px 40px;\n  text-align: center;\n  max-width: 100%;\n\n  // --- CABEÇALHO ---\n  .modal-header {\n    margin-bottom: 35px;\n\n    h1 {\n      font-size: 1.4rem;\n      font-weight: 700;\n      color: #333;\n      margin-bottom: 12px;\n    }\n\n    p {\n      font-size: 0.95rem;\n      color: #777;\n      margin: 0;\n      line-height: 1.4;\n    }\n  }\n\n  // --- CORPO DO FORMULÁRIO (SELECTS + ÍCONE) ---\n  .row-selectors {\n    display: flex;\n    align-items: flex-start; // Centraliza verticalmente o ícone com os selects\n    justify-content: center;\n    gap: 20px;\n    margin-bottom: 15px;\n\n    .field {\n      flex: 1;\n      \n      // Ajuste para garantir que o material-field não adicione padding extra\n      ::ng-deep .mat-form-field-wrapper {\n        padding-bottom: 0;\n      }\n    }\n\n    .divider-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 56px; // Altura aproximada do mat-form-field outline\n\n      img {\n        width: 28px;\n        height: auto;\n      }\n    }\n  }\n\n  // --- SEÇÃO DO CHECKBOX ---\n  .row-checkbox {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 45px;\n\n    ::ng-deep .mat-checkbox-layout {\n      white-space: normal; // Permite quebra de linha no mobile\n    }\n\n    .checkbox-text {\n      color: #666;\n      font-size: 0.95rem;\n    }\n\n    // Estilo para quando o checkbox está marcado\n    ::ng-deep .mat-checkbox-checked.mat-warn .mat-checkbox-background {\n      background-color: #b71c1c !important;\n    }\n  }\n\n  // --- RODAPÉ (BOTÕES) ---\n  .modal-footer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 30px;\n\n    // Botão \"Copiar\"\n    .btn-confirm {\n      min-width: 150px;\n      padding: 6px 40px;\n      border-radius: 8px;\n      font-weight: 700;\n      font-size: 1rem;\n      text-transform: none;\n      \n      // Estilo Padrão / Desabilitado (image_eb5006)\n      background-color: #e0e0e0;\n      color: #8a8a8a;\n\n      // Estilo quando o formulário é VÁLIDO (image_eb5028)\n      &:not(:disabled) {\n        background-color: #b71c1c !important; \n        color: white !important;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    // Botão \"Cancelar\"\n    .btn-cancel {\n      color: #b71c1c;\n      font-weight: 700;\n      font-size: 1rem;\n      text-transform: none;\n      \n      &:hover {\n        background: transparent;\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n// --- RESPONSIVIDADE (MOBILE) ---\n@media (max-width: 600px) {\n  .modal-wrapper {\n    padding: 20px 15px;\n\n    .row-selectors {\n      flex-direction: column; // Empilha os campos\n      gap: 10px;\n\n      .field {\n        width: 100%; // Ocupa 100% da largura\n      }\n\n      .divider-icon {\n        width: 100%;\n        height: auto;\n        margin: 5px 0 15px 0;\n        transform: rotate(90deg); // Seta aponta para baixo no mobile\n\n        img {\n          width: 32px;\n        }\n      }\n    }\n\n    .row-checkbox {\n      margin-bottom: 30px;\n    }\n\n    .modal-footer {\n      flex-direction: column; // Botões um sobre o outro\n      gap: 15px;\n\n      .btn-confirm {\n        width: 100%;\n        order: 1; // Garante que o \"Copiar\" venha primeiro\n      }\n\n      .btn-cancel {\n        order: 2;\n      }\n    }\n  }\n}\n.buttons{\n width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 32px;\n  margin-bottom: 32px;\n   .btn-back{\n    width: 8rem !important;\n  }\n  a {\n      text-decoration: none;\n      color: #AE0F0A;\n      margin-left: 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
